import React from 'react';
import PropTypes from 'prop-types';

/**
 * Marks a place on screen by name (anchors) without changing the layout: it has no box of its own, so FlyingCards
 * measures its first child instead.
 */
const Anchor = ({ name, children }) => (
  <span data-anchor={name} style={{ display: 'contents' }}>{children}</span>
);

Anchor.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Anchor;
